import { createClient } from "@supabase/supabase-js";
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey)
    throw new Error(
        "Missing Supabase env vars. Define REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_KEY.",
    );

const supabase = createClient(supabaseUrl, supabaseKey);

export function getImageUrl(path) {
    return supabase.storage.from("images").getPublicUrl(path).data.publicUrl;
}

export default supabase;
